// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const TogetherPlayButton = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m27.768 19.02-.248.434L16.386 13.1a.777.777 0 0 0-.761-.001.733.733 0 0 0-.375.634v12.534c0 .257.142.5.371.631a.773.773 0 0 0 .757.006l11.134-6.18a.734.734 0 0 0 .38-.634.732.732 0 0 0-.372-.636l.248-.435Zm1.125 1.076a1.734 1.734 0 0 1-.895 1.502l-11.135 6.18a1.774 1.774 0 0 1-1.74-.012 1.734 1.734 0 0 1-.873-1.499V13.733c0-.62.338-1.197.882-1.504a1.777 1.777 0 0 1 1.75.003l11.134 6.353c.544.31.88.889.877 1.51Z"
			fill="#383838"
		/>
		<circle cx={20} cy={20} r={19.5} stroke="#383838" />
	</svg>
);
export default TogetherPlayButton;
